import {makeReactContext} from 'lib/makeReactContext';

export interface MethodEditorContextValue {
  selectedStepCid: string | null;
}

const MethodEditorContext = makeReactContext<MethodEditorContextValue>(
  () => ({selectedStepCid: null}),
  'MethodEditorContext'
);

export default MethodEditorContext;
